import { Breakpoint } from '@24i/nxg-sdk-smartott/src/utils/styles/constants';

export const MODAL_BREAKPOINT = Breakpoint.SM;

export enum MANAGE_DEVICES_MODES {
    ONBOARDING = 'ONBOARDING',
    ACCOUNT = 'ACCOUNT',
}
